import styled from 'styled-components';

/**
 * Simplified masonry (CSS columns) rather than the in-app JS masonry engine
 * used by MessagesList — close visual match without pulling in the
 * drag/select/thread machinery that component assumes an authenticated
 * session for. Shared by any read-only message listing (published folders
 * today; the "Shared with me" folder view can reuse this too — same visual
 * concept as the in-app board, independent implementation, not the same
 * component tree).
 */
const ReadOnlyMessageGrid = styled.div`
    column-count: 3;
    column-gap: 12px;

    @media (max-width: 900px) {
        column-count: 2;
    }

    @media (max-width: 560px) {
        column-count: 1;
    }
`;

export default ReadOnlyMessageGrid;
